<template>
    <div class="dev-page">
        <div class="container">
            <div class="dev-promo">
                <img src="https://admin.shablon.bazis.kz/media/bazis-logo_2023.svg" alt="">
                <h1>САЙТ НАХОДИТСЯ В РАЗРАБОТКЕ</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'dev--page',
        components: {
        },
        data () {
            return {
                projectNameG: window.host,
            }
        },
    }
</script>

<style lang="scss">
    @import '@/styles/components/pages/dev-page.scss';
</style>